<main>
    <div class="admin_left">
        <app-menu-admin></app-menu-admin>
    </div>
    <div class="admin_right">
        <h4><b>Rapports</b></h4>
        <div class="admin_right_ctn">
            <div class="admin_select_ctn">
                <label for="operation">Choisissez votre opération:</label>
                <select class="admin_select" name="operation" [(ngModel)] = "selectionnedOption">
                    <option value="1">Toute l'année: Utilisateurs</option>
                    <option value="2">Temps forts: Utilisateurs</option>
                    <option value="3">Toute l'année: Classes</option>
                    <option value="4">Temps forts: Classes</option>
                    <option value="5">Toute l'année: Activités par écoles</option>
                    <option value="6">Temps forts: Activités par écoles</option>
                    <option value="7">Toute l'année: Activités par utilisateur</option>
                    <option value="8">Temps forts: Activités par utilisateur</option>
                </select>
            </div>
            <div *ngIf="selectionnedOption == '1'" class="admin_operation_liste">
                <p class="research_result">{{this.allUsersNum}} resultats obtenus</p>
                <div class="admin_table_ctn">
                    <table class="excel-table">
                        <thead style="color: white;background-color: black;">
                            <tr>
                                <td>Prénom</td>
                                <td>Nom</td>
                                <td>Seul</td>
                                <td>En famille</td>
                                <td>En classe</td>
                                <td>Total</td>
                                <td>Nom de la classe</td>
                                <td>École</td>
                                <td>Région</td>
                            </tr>
                        </thead>
                        <tbody class="table_body">
                        </tbody>
                    </table>  
                </div>
                <button (click)="exportexcel()" class="admin_export_button">Exporter le resultat</button>
            </div>
            <div *ngIf="selectionnedOption == '2'" class="admin_operation_temps_forts">
                Sélectionner la période:
                <div class="admit_temps_forts_selects">
                    <label for="temps_debut">
                        Début:
                        <input class="admin_debut" [(ngModel)]="admin_debut" type="date">
                    </label>
                    <label for="temps_debut">
                        Fin:
                        <input class="admin_fin" [(ngModel)]="admin_fin" type="date">
                    </label>
                    <button class="admin_search_button" (click)="getUtilisateursTempsFort()">Rechercher</button>
                </div>
                <p class="research_result">{{utilisateursTemps.length}} resultats obtenus</p>
                <div class="admin_table_ctn">
                    <table class="excel-table_fort">
                        <thead style="color: white;background-color: black;">
                            <tr>
                                <td>Prénom</td>
                                <td>Nom</td>
                                <td>Seul</td>
                                <td>En famille</td>
                                <td>En classe</td>
                                <td>Total</td>
                                <td>École</td>
                                <td>Région</td>
                            </tr>
                        </thead>
                        <tbody class="table_body_fort">
                            <tr *ngFor="let utilisateur of utilisateursTemps">
                                <td>{{utilisateur.prenom}}</td>
                                <td>{{utilisateur.nom}}</td>
                                <td>{{utilisateur.seul}}</td>
                                <td>{{utilisateur.enFamille}}</td>
                                <td>{{utilisateur.enClasse}}</td>
                                <td>{{utilisateur.total}}</td>
                                <td>{{utilisateur.ecole}}</td>
                                <td>{{utilisateur.region}}</td>
                            </tr>
                        </tbody>
                    </table>  
                </div>
                <button (click)="exportexcel()" class="admin_export_button">Exporter le resultat</button>
            </div>
            <div *ngIf="selectionnedOption == '3'" class="admin_operation_classes">
                <p class="research_result">0 resultats obtenus</p>
                <div class="admin_table_ctn">
                    <table class="excel-classes_table">
                        <thead style="color: white;background-color: black;">
                            <tr>
                                <td>Nom de classe</td>
                                <td>Nombre d'élèves</td>
                                <td>Total d'étoiles</td>
                                <td>Niveau</td>
                                <td>École</td>
                                <td>Région</td>
                            </tr>
                        </thead>
                        <tbody class="table_classe_body"></tbody>
                    </table>  
                </div>
                <button (click)="exportexcel()" class="admin_export_button">Exporter le resultat</button>
            </div>
            <div *ngIf="selectionnedOption == '4'" class="admin_operation_temps_forts_classes">
                Sélectionner la période:
                <div class="admit_temps_forts_selects">
                    <label for="temps_debut">
                        Début :
                        <input class="admin_debut" [(ngModel)]="admin_debut" type="date">
                    </label>
                    <label for="temps_debut">
                        Fin:
                        <input class="admin_fin" [(ngModel)]="admin_fin" type="date">
                    </label>
                    <button class="admin_search_button" (click)="getClassesTempsForts()">Rechercher</button>
                </div>
                <p class="research_result">0 resultats obtenus</p>
                <div class="admin_table_ctn">
                    <table class="excel-table_classes_fort">
                        <thead style="color: white;background-color: black;">
                            <tr>
                                <td>Nom de classe</td>
                                <td>Nombre d'élèves</td>
                                <td>Total d'étoiles</td>
                                <td>Niveau</td>
                                <td>École</td>
                                <td>Région</td>
                            </tr>
                        </thead>
                        <tbody class="table_classes_body_fort">
                        </tbody>
                    </table>  
                </div>
                <button (click)="exportexcel()" class="admin_export_button">Exporter le resultat</button>
            </div>
            <div *ngIf="selectionnedOption == '5'" class="admin_operation_activities">
                <p class="research_result">{{ecolesActivities.length}} resultats obtenus</p>
                <div class="admin_table_ctn">
                    <table class="excel-classes_table_activities">
                        <thead style="color: white;background-color: black;">
                            <tr>
                                <td style="width: 15%;">Nom de l'école</td>
                                <td style="width: 7.5%;">Total d'étoiles</td>
                                <td style="width: 7.5%;">Région</td>
                                <td style="width: 7.5%;" *ngFor="let activity of activities | async">{{activity.activiteName}}</td>
                            </tr>
                        </thead>
                        <tbody class="table_activities_classe_body">
                            <tr *ngFor="let ecole of ecolesActivities">
                                <td>{{ecole.ecoleName}}</td>
                                <td>{{ecole.total?.toFixed(1)}}</td>
                                <td>{{ecole.region}}</td>
                                <td>{{ecole.athletisme?.toFixed(1)}}</td>
                                <td>{{ecole.badminton?.toFixed(1)}}</td>
                                <td>{{ecole.improvisation?.toFixed(1)}}</td>
                                <td>{{ecole.miniHandball?.toFixed(1)}}</td>
                                <td>{{ecole.soccer?.toFixed(1)}}</td>
                                <td>{{ecole.ultimateFrisbee?.toFixed(1)}}</td>
                                <td>{{ecole.veloDEmontagne?.toFixed(1)}}</td>
                                <td>{{ecole.voix?.toFixed(1)}}</td>
                                <td>{{ecole.volleyBall?.toFixed(1)}}</td>
                                <td>{{ecole.autresSportives?.toFixed(1)}}</td>
                                <td>{{ecole.autresCulturelles?.toFixed(1)}}</td>
                                <td>{{ecole.leadership?.toFixed(1)}}</td>
                            </tr>
                        </tbody>
                    </table>  
                </div>
                <button (click)="exportexcel()" class="admin_export_button">Exporter le resultat</button>
            </div>
            <div *ngIf="selectionnedOption == '6'" class="admin_operation_temps_forts_activities">
                Sélectionner la période:
                <div class="admit_temps_forts_selects">
                    <label for="temps_debut">
                        Début :
                        <input class="admin_debut" [(ngModel)]="admin_debut" type="date">
                    </label>
                    <label for="temps_debut">
                        Fin:
                        <input class="admin_fin" [(ngModel)]="admin_fin" type="date">
                    </label>
                    <button class="admin_search_button" (click)="this.getActivitiesBySchoolTemps()">Rechercher</button>
                </div>
                <p class="research_result">{{ecolesActivities.length}} resultats obtenus</p>
                <div class="admin_table_ctn">
                    <table class="excel-table_activities_fort">
                        <thead style="color: white;background-color: black;">
                            <tr>
                                <td style="width: 15%;">Nom de l'école</td>
                                <td style="width: 7.5%;">Total d'étoiles</td>
                                <td style="width: 7.5%;">Région</td>
                                <td style="width: 7.5%;" *ngFor="let activity of activities | async">{{activity.activiteName}}</td>
                            </tr>
                        </thead>
                        <tbody class="table_activities_body_fort">
                            <tr *ngFor="let ecole of ecolesActivities">
                                <td>{{ecole.ecoleName}}</td>
                                <td>{{ecole.total?.toFixed(1)}}</td>
                                <td>{{ecole.region}}</td>
                                <td>{{ecole.athletisme?.toFixed(1)}}</td>
                                <td>{{ecole.badminton?.toFixed(1)}}</td>
                                <td>{{ecole.improvisation?.toFixed(1)}}</td>
                                <td>{{ecole.miniHandball?.toFixed(1)}}</td>
                                <td>{{ecole.soccer?.toFixed(1)}}</td>
                                <td>{{ecole.ultimateFrisbee?.toFixed(1)}}</td>
                                <td>{{ecole.veloDEmontagne?.toFixed(1)}}</td>
                                <td>{{ecole.voix?.toFixed(1)}}</td>
                                <td>{{ecole.volleyBall?.toFixed(1)}}</td>
                                <td>{{ecole.autresSportives?.toFixed(1)}}</td>
                                <td>{{ecole.autresCulturelles?.toFixed(1)}}</td>
                                <td>{{ecole.leadership?.toFixed(1)}}</td>
                            </tr>
                        </tbody>
                    </table>  
                </div>
                <button style="height: 2rem;" (click)="exportexcel()" class="admin_export_button">Exporter le resultat</button>
            </div>
            <div *ngIf="selectionnedOption == '7'" class="admin_operation_activities_user">
                <p class="research_result">{{userActivities.length}} resultats obtenus</p>
                <div class="admin_table_ctn">
                    <table class="excel-classes_table_activities_user">
                        <thead style="color: white;background-color: black;">
                            <tr>
                                <td >Prenom</td>
                                <td >Nom</td>
                                <td style="width: 7.5%;">École</td>
                                <td style="width: 7.5%;">Région</td>
                                <td style="width: 7.5%;" *ngFor="let activity of activities | async">{{activity.activiteName}}</td>
                            </tr>
                        </thead>
                        <tbody class="table_activities_user_body">
                            <tr *ngFor="let user of userActivities">
                                <td>{{user.prenom}}</td>
                                <td>{{user.nom}}</td>
                                <td>{{user.ecole}}</td>
                                <td>{{user.region}}</td>
                                <td>{{user.athletisme?.toFixed(1)}}</td>
                                <td>{{user.badminton?.toFixed(1)}}</td>
                                <td>{{user.improvisation?.toFixed(1)}}</td>
                                <td>{{user.miniHandball?.toFixed(1)}}</td>
                                <td>{{user.soccer?.toFixed(1)}}</td>
                                <td>{{user.ultimateFrisbee?.toFixed(1)}}</td>
                                <td>{{user.veloDEmontagne?.toFixed(1)}}</td>
                                <td>{{user.voix?.toFixed(1)}}</td>
                                <td>{{user.volleyBall?.toFixed(1)}}</td>
                                <td>{{user.autresSportives?.toFixed(1)}}</td>
                                <td>{{user.autresCulturelles?.toFixed(1)}}</td>
                                <td>{{user.leadership?.toFixed(1)}}</td>
                            </tr>
                        </tbody>
                    </table>  
                </div>
                <button (click)="exportexcel()" class="admin_export_button">Exporter le resultat</button>
            </div>
            <div *ngIf="selectionnedOption == '8'" class="admin_operation_temps_forts_activities_user">
                Sélectionner la période:
                <div class="admit_temps_forts_selects">
                    <label for="temps_debut">
                        Début :
                        <input class="admin_debut" [(ngModel)]="admin_debut" type="date">
                    </label>
                    <label for="temps_debut">
                        Fin:
                        <input class="admin_fin" [(ngModel)]="admin_fin" type="date">
                    </label>
                    <button class="admin_search_button" (click)="this.getUserActivitiesTemps()">Rechercher</button>
                </div>
                <p class="research_result">{{userActivitiesTemps.length}} resultats obtenus</p>
                <div class="admin_table_ctn">
                    <table class="excel-table_activities_user_fort">
                        <thead style="color: white;background-color: black;">
                            <tr>
                                <td >Prénom</td>
                                <td >Nom</td>
                                <td style="width: 7.5%;">École</td>
                                <td style="width: 7.5%;">Région</td>
                                <td style="width: 7.5%;" *ngFor="let activity of activities | async">{{activity.activiteName}}</td>
                            </tr>
                        </thead>
                        <tbody class="table_activities_body_fort">
                            <tr *ngFor="let user of userActivitiesTemps">
                                <td>{{user.prenom}}</td>
                                <td>{{user.nom}}</td>
                                <td>{{user.ecole}}</td>
                                <td>{{user.region}}</td>
                                <td>{{user.athletisme?.toFixed(1)}}</td>
                                <td>{{user.badminton?.toFixed(1)}}</td>
                                <td>{{user.improvisation?.toFixed(1)}}</td>
                                <td>{{user.miniHandball?.toFixed(1)}}</td>
                                <td>{{user.soccer?.toFixed(1)}}</td>
                                <td>{{user.ultimateFrisbee?.toFixed(1)}}</td>
                                <td>{{user.veloDEmontagne?.toFixed(1)}}</td>
                                <td>{{user.voix?.toFixed(1)}}</td>
                                <td>{{user.volleyBall?.toFixed(1)}}</td>
                                <td>{{user.autresSportives?.toFixed(1)}}</td>
                                <td>{{user.autresCulturelles?.toFixed(1)}}</td>
                                <td>{{user.leadership?.toFixed(1)}}</td>
                            </tr>
                        </tbody>
                    </table>  
                </div>
                <button style="height: 2rem;" (click)="exportexcel()" class="admin_export_button">Exporter le resultat</button>
            </div>
        </div>
    </div>
</main>